/**
 * Setup equal height curriculum/programs VC table columns.
 */
jQuery(function($){
    $('.vc_row', '.table-section').addClass('equal-height');
    $('.vc_row > .wpb_column', '.table-section').addClass('equal-height-item');
    $(window).trigger('resize');
});

/**
 * Setup page navigation. Uses the third-level menu from the site primary menu.
 */
jQuery(function($){
    var page_nav = $('<div id="page-navigation" class="page-nav-container"></div>');
    if ($('body').hasClass('page-template-page-banner')) {
        page_nav.insertBefore('.entry-content');
    } else {
        page_nav.prependTo('#content');
    }
    // find third-level menu and append
    $('.current-menu-ancestor .current_page_item .sub-menu-container', '.menu-primary-container').appendTo(page_nav);
    $('.current-menu-ancestor .current-menu-ancestor .current_page_item', '.menu-primary-container').closest('.sub-menu-container').appendTo(page_nav);
    function setPageNavigationCurrentMenuItem() {
        var page_nav = $('#page-navigation');
        $('a', page_nav).each(function() {
            $(this).closest('li').removeClass('current-menu-item');
        });
        $('a', page_nav).each(function() {
            if (this.hostname == window.location.hostname && this.pathname == window.location.pathname && this.hash == window.location.hash) {
                $(this).closest('li').addClass('current-menu-item');
                return false;
            }
        });
    }
    $(window).on('hashchange', setPageNavigationCurrentMenuItem);
    setPageNavigationCurrentMenuItem();
});
